export interface QuoteTemplate {
  id: string;
  providerId: string;
  name: string;
  category: string;
  description: string;
  basePrice: number;
  maxPrice?: number;
  timeEstimate: string; // "2-4 hours"
  materialsIncluded: boolean;
  warranty: string; // "6 months parts & labor"
  notes?: string;
  isActive: boolean;
  usageCount: number;
  successRate: number; // percentage of quotes that got accepted
  createdAt: Date;
  updatedAt: Date;
}

export interface QuoteTemplateCategory {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export const QUOTE_CATEGORIES: QuoteTemplateCategory[] = [
  {
    id: 'plumbing',
    name: 'Plumbing',
    icon: 'Wrench',
    description: 'Pipes, fixtures, and water systems'
  },
  {
    id: 'electrical',
    name: 'Electrical',
    icon: 'Zap',
    description: 'Wiring, outlets, and electrical systems'
  },
  {
    id: 'hvac',
    name: 'HVAC',
    icon: 'Wind',
    description: 'Heating, ventilation, and air conditioning'
  },
  {
    id: 'general',
    name: 'General Maintenance',
    icon: 'Hammer',
    description: 'General repairs and maintenance'
  },
  {
    id: 'emergency',
    name: 'Emergency Services',
    icon: 'AlertTriangle',
    description: 'Urgent and emergency repairs'
  },
  {
    id: 'custom',
    name: 'Custom Services',
    icon: 'Settings',
    description: 'Specialized or custom services'
  }
];